import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var helperText = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_4og8mk1',variantClassNames:{state:{'default':'fx_2d2fb1e5_4og8mk2',error:'fx_2d2fb1e5_4og8mk3'},withInField:{true:'fx_2d2fb1e5_4og8mk4',false:'fx_2d2fb1e5_4og8mk5'}},defaultVariants:{state:'default'},compoundVariants:[]});

export { helperText };
//# sourceMappingURL=helperText.vanilla.mjs.map
